import type React from 'react'

export const IconDashed: React.FC<{ width?: number }> = ({ width }) => (
  <svg
    width={width || 17}
    height={width || 16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.25"
      y="1.75"
      width="12.5"
      height="12.5"
      rx="2.05"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="0.5"
      y="5.99976"
      width="16"
      height="4"
      fill="var(--color-code-bw-13)"
    />
    <rect
      x="6.5"
      y="15.9998"
      width="16"
      height="4"
      transform="rotate(-90 6.5 15.9998)"
      fill="var(--color-code-bw-13)"
    />
  </svg>
)
